import React from "react";
import { Route } from "react-router-dom";
import Faucet from "../screens/Faucet";
import MyPartners from "../screens/MyPartners";
import ViewProduct from "../screens/ViewProduct";
import VLETransfer from "../screens/VLETransfer";
import CreateUpdateFarmer from "../screens/CreateUpdateFarmer";
import FarmersList from "../screens/FarmersList";
import WalletScreen from "../screens/WalletScreen";
import PendingTransfers from "../screens/PendingTransfers";
import ComingSoon from "../screens/ComingSoon";
import Profile from "../screens/Profile";
import CreateExternalSoilReport from "../screens/farmer/CreateExternalSoilReport";
import ExternalSoilTestReport from "../screens/farmer/ExternalSoilTestReport";
import ResetPassword from "../screens/ResetPassword";
import UpdatePassword from "../screens/UpdatePassword";
import SupportChatHome from "../screens/support/SupportChatHome";
import ChatAdvisory from "../screens/support/ChatAdvisory";
import { HOME_PAGE } from "../globals/const";
import SoilTestReportForm from "../screens/soiltesting/SoilTestReportForm";
import SoilTesting from "../screens/soiltesting/SoilTesting";
import SoilTestReport from "../screens/soiltesting/SoilTestReport";
import SubscriptionInvoicing from "../screens/payments/SubscriptionInvoicing";
import ViewInvoice from "../screens/payments/ViewInvoice";
import ListInvoices from "../screens/payments/ListInvoices";
import WeatherSubscriptionAlerts from "../components/weather/WeatherSubscriptionAndAlerts";

export const getCommonAuthRoutes = (role) => [
  <Route key="faucet" path="/faucet" element={<Faucet />} />,
  <Route key="partners" path="/partners" element={<MyPartners />} />,
  <Route key="view-product" path="/view-product" element={<ViewProduct />} />,
  <Route
    key="vle-transfer"
    path="/vle-transfer/:id"
    element={<VLETransfer role={role} />}
  />,
  <Route
    key="farmer-add"
    path="/farmer/add"
    element={<CreateUpdateFarmer role={role} />}
  />,
  <Route
    key="farmer-edit"
    path="/farmer/edit/:id"
    element={<CreateUpdateFarmer />}
  />,
  <Route
    key="farmers-list"
    path="/farmers-list/"
    element={<FarmersList role={role} />}
  />,
  <Route
    key="default-wallet"
    path="/"
    element={<WalletScreen walletType="DEFAULT" />}
  />,
  <Route
    key="pending-transfers"
    path="/pending-transfers"
    element={<PendingTransfers />}
  />,
  <Route key="coming-soon" path="/coming-soon" element={<ComingSoon />} />,
  <Route key="profile" path="/profile" element={<Profile />} />,
  <Route
    key="create-external-soil-report"
    path="/create-external-soil-report"
    element={<CreateExternalSoilReport />}
  />,
  <Route
    key="external-soil-report"
    path="/external-soil-report/:reportId"
    element={<ExternalSoilTestReport />}
  />,
  <Route
    key="support-chat"
    path="/support-chat"
    element={<SupportChatHome />}
  />,
  <Route
    key="conversation"
    path="/conversation/:id"
    element={<ChatAdvisory />}
  />,
  <Route
    key="reset-password"
    path={`${HOME_PAGE}/reset-password`}
    element={<ResetPassword />}
  />,
  <Route
    key="update-password"
    path={`${HOME_PAGE}/update-password`}
    element={<UpdatePassword />}
  />,
  <Route
    key="soil-test-report-form"
    path="/soil-test-report-form"
    element={<SoilTestReportForm />}
  />,
  <Route key="soil-testing" path="/soil-testing" element={<SoilTesting />} />,
  <Route
    key="soil-testing-report-detail"
    path="/soil-test-report/:reportId"
    element={<SoilTestReport />}
  />,
  <Route
    key="subscription-invoicing"
    exact
    path="/subscription-invoicing"
    element={<SubscriptionInvoicing />}
  />,
  <Route
    key="subscription-invoicing"
    exact
    path="/invoice/:invoiceId"
    element={<ViewInvoice />}
  />,
  <Route
    key="subscription-invoice-list"
    exact
    path="/my-invoices"
    element={<ListInvoices />}
  />,
  <Route
    key="weather-subscription-alerts"
    path="/weather-subscription-alerts"
    element={<WeatherSubscriptionAlerts />}
  />,
];
